import React from 'react';
import { Link } from 'react-router-dom';
import analyticsService from '../../shared/analytics/analytics-service';
import { useDispatch } from 'react-redux';

export default function BackTo({ recurring, modify, fromSuccess }) {
  const dispatch = useDispatch();


  function sendAnalytics() {
    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "back to account"
      }
    })
    if(fromSuccess){
      dispatch({ type: 'PAYMENT_METHODS_LOADING' });
    }
  }

  if (recurring && modify) {
    return (
      <Link
        className="button"
        to="/payment/summary/payments"
        desktopbefore="Back to My"
        onClick={sendAnalytics}
      >
        Payments
      </Link>
    );
  }

  return (
    <Link className="button" to="/payment/summary/payments" desktopbefore="Back to" onClick={sendAnalytics}>
      Account
    </Link>
  );
}
